// extracted by mini-css-extract-plugin
export default {"box":"approval_box__Mwe+w"};